// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close_sp_modal p {
  margin: 8px 0;
}

.close_sp_modal_table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
}

.close_sp_modal_table th,
.close_sp_modal_table td {
  text-align: left;
  padding: 6px 8px;
  border-bottom: 1px solid var(--border);
}

.close_sp_modal_warning {
  color: #F59E0B;
}

.close_sp_modal_actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/structured/components/closeProductModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB","sourcesContent":[".close_sp_modal p {\n  margin: 8px 0;\n}\n\n.close_sp_modal_table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 10px 0;\n}\n\n.close_sp_modal_table th,\n.close_sp_modal_table td {\n  text-align: left;\n  padding: 6px 8px;\n  border-bottom: 1px solid var(--border);\n}\n\n.close_sp_modal_warning {\n  color: #F59E0B;\n}\n\n.close_sp_modal_actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
